import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getDashboard = () => async (dispatch) => {
    dispatch({
        type: 'SESAME_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/sesame/getDashboard', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SESAME_GET_SUCCESS',
                payload: data
            })
        }
        if (status === 500) {
            dispatch({
                type: 'SESAME_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SESAME_NOT_LOADING'
        })
    }
}